export const SINGLE_PHASE = 'single phase'
export const THREE_PHASE = 'three phase'

export const METER_INPUT_TYPE = [SINGLE_PHASE, THREE_PHASE]
